<template>
    <div class="wenjuan-template">
        <div v-for="(question, index) in localQuestions" :key="index" class="question-item">
            <div class="question-header">
                <el-tag size="mini" effect="dark" :type="question.required === true ? 'success' : 'info'">{{ index + 1 }}</el-tag>
                {{ question.label }} 
            </div>

            <!-- 单选题 -->
            <div v-if="question.type === 'radio'" class="options">
                <div v-for="(option,qindex) in question.options" class="item">
                    <div class="answer">
                        <input type="radio" :checked="getAnswer(question.id) === qindex" disabled /> {{ option.text }}
                    </div>
                    <div v-if="option.show_input && getAnswer(question.id) === qindex" class="radio_input_box">
                        <el-input disabled size="mini" :value="getRadioInput(question.id)" />
                    </div>
                </div>
            </div>

            <!-- 多选题 -->
            <div v-if="question.type === 'checkbox'" class="options">
                <div v-for="(option,qindex) in question.options" class="item">
                    <div class="answer">
                        <input type="checkbox" :checked="getAnswer(question.id) && getAnswer(question.id).includes(qindex)" disabled /> {{ option.text }}
                    </div>
                    <div v-if="option.show_input" class="radio_input_box">
                        <el-input disabled size="mini" :value="getCheckboxInput(question.id)[qindex]" />
                    </div>
                </div>
            </div>

            <!-- 输入框 -->
            <div v-if="question.type === 'text'">
                <el-input size="small" :placeholder="getAnswer(question.id)" :disabled="true"></el-input>
            </div>

            <!-- 多项填空题 -->
            <div v-if="question.type === 'multiple_text'">
                <div v-for="(opt, optIndex) in question.options" :key="optIndex" class="option">
                    {{ opt.text }}
                    <el-input size="small" :placeholder="getAnswer(question.id)[optIndex]" :disabled="true"></el-input>
                </div>
            </div>

            <!-- 选择照片 -->
            <div v-if="question.type === 'image' && bigTaskId === 3" class="image_box">

                <div v-for="(option,qindex) in question.options" class="item" :class="{'active': getAnswer(question.id) && (Number(getAnswer(question.id)) === qindex) }" >
                    <img :src="option.src" />
                    <i class="el-icon-check" v-if="getAnswer(question.id) && (Number(getAnswer(question.id)) === qindex)"></i>
                </div>
            </div>

            <!-- 头像 -->
            <div v-if="question.type === 'image' && bigTaskId === 1" class="image_box">
                <div class="item" v-if="getAnswer(question.id)">
                    <img style="opacity: 1;" :src="getAnswer(question.id)" />
                </div>                
            </div>

            <!-- 上传文件 -->
            <div v-if="question.type === 'file'" class="file_box">
                <div class="item" v-if="getAnswer(question.id)" v-for="(opt, optIndex) in (getAnswer(question.id)||'').split(',')">
                    <el-tag size="mini">{{ optIndex + 1 }}</el-tag><a :href="opt" target="_blank">{{ opt }}</a>
                </div>
            </div>

            <!-- 评分星星 -->
            <el-rate v-if="question.type === 'star'" disabled :value="Number(getAnswer(question.id))" style=" margin-top: 10px;" :max="10" />
            
            <!-- 评分 -->
            <div v-if="question.type === 'rating'" class="ratebox">
                <div class="rate_item" :class="{'active':item === (getAnswer(question.id) && Number(getAnswer(question.id)))}" v-for="(item,rateIndex) in 10">{{ item }}</div>
            </div>

            <!-- 其它 -->
            <div v-if="['select','career','address','education','income','phone_brand'].includes(question.type)" class="select_style">
                <el-select v-model="select" size="small" :placeholder="getAnswer(question.id) && getAnswer(question.id).toString()" disabled style="width: 100%">
                </el-select>
            </div>
        </div>

        <!-- 视频/网页任务 -->
        <div v-if="bigTaskId === 2">
            <video v-if="value && (value.endsWith('.mp4') || value.endsWith('.webm'))" width="320" height="180" controls preload="metadata" :key="value">
                <source :src="value" type="video/mp4">
            </video>
            <div v-else>{{ value }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['value','questionContent','bigTaskId','videoDuration'],
    data() {
        return {
            select: []
        }
    },
    computed: {
        localContent() {
            return this.parseQuestions(this.value);
        },
        localQuestions() {
            return this.parseQuestions(this.questionContent);
        }
    },
    methods: {
        parseQuestions(value) {
            try {
                const parsed = JSON.parse(value);
                if (typeof parsed === 'object' && parsed !== null) {
                    return parsed;
                }
                throw new Error();
            } catch {
                return []
            }
        },
        getAnswer(id) {
            return this.localContent.find(c => c.questionId == id) ? this.localContent.find(c => c.questionId == id).answer : "";
        },
        getRadioInput(id) {
            return this.localContent.find(c => c.questionId == id) ? this.localContent.find(c => c.questionId == id).input : "";
        },
        getCheckboxInput(id) {
            return this.localContent.find(c => c.questionId == id) ? this.parseQuestions(this.localContent.find(c => c.questionId == id).input) : [];
        }
    }
}
</script>

<style scoped>
.wenjuan-template {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}
.question-item {
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #eee;
  width: 49%;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.2),1px 1px 2px rgba(0, 0, 0, 0.1); 
}
.options .item {
    display: flex; 
    align-items: center;
    box-sizing: border-box;
    flex-wrap: wrap;
    margin: 5px 0;
}
.options .answer {
    width: 100%;
    line-height: normal;
    display: flex;
    gap: 5px;
}
.options .radio_input_box {
    width: 100%;
}
.ratebox {
    display: flex;
    padding: 10px 0 5px 0;
    justify-content: space-between;
}
.ratebox .rate_item {
    border: solid 1px #E4E7ED;
    border-radius: 100%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.ratebox .rate_item.active {
    background: rgba(103, 194, 58, 1);
    border: solid 1px rgba(103, 194, 58, 1);
    color: #fff;
}
.question-item .image_box {
    display: flex;
}
.question-item .image_box .item {
    width: 48px;
    display: flex;
    flex-wrap: wrap;
    margin-right: 5px;
    position: relative;
}
.question-item .image_box .item img {
    width: 48px;
    height: 48px;
    border-radius: 2px;
    display: block;
    opacity: 0.2;
}
.question-item .image_box .item.active img {
    opacity: 1;
}
.question-item .image_box .item.active i {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    font-size: 32px;
    color: rgba(103, 194, 58, 1);
}
.file_box .item{
    line-height: 16px;
    display: flex;
    gap: 5px;
    margin-bottom: 8px;
}
</style>